import { useCallback, useEffect, useRef, useState } from 'react'

/** A field in error. A button, such as a date picker's, may not carry aria-invalid, so it marks itself with data-invalid. */
export const invalidFieldSelector = '[aria-invalid="true"], [data-invalid="true"]'

/**
 * For a form that saves outside `RecordForm`, such as one in a dialog: after a refused save,
 * `reveal()` focuses the first field in error inside `ref`, once its error has rendered.
 */
export function useFocusFirstInvalid<T extends HTMLElement>() {
  const ref = useRef<T>(null)
  const [revealed, setRevealed] = useState(0)
  useEffect(() => {
    if (revealed > 0) {
      ref.current?.querySelector<HTMLElement>(invalidFieldSelector)?.focus()
    }
  }, [revealed])
  const reveal = useCallback(() => setRevealed((count) => count + 1), [])
  return { ref, reveal }
}
